module.exports = __webpack_public_path__ + "img/error.deaadbc9.png";